'use strict';

var angular = require('angular');
var _ = require('lodash');
var FareChangeGridController = function FareChangeGridController($scope, $state, dataProviderService, fareChangeGridConfigurationService, heatmapColorService, transitionSearchCriteriaService, momentService, hepService) {
  var DEFAULT_AGGREGATION_METHOD = 'byMonth';
  var runFrequency = hepService.getSimpleHepProperty('DYNAMIC_PRICING_RECOM_FREQUENCY');
  $scope.aggregationMethod = DEFAULT_AGGREGATION_METHOD;
  var source = {};
  $scope.currentFilter = null;
  source.localdata = [];
  source.datafields = [];
  $scope.gridSettings = {
    width: '100%',
    height: 250,
    altrows: true,
    enablehover: false,
    columns: [],
    source: new angular.element.jqx.dataAdapter(source)
  };
  $scope.gridId = 'fare-change-grid';
  $scope.resetGrid = function () {
    source.localdata = [];
    $scope.gridSettings.source.dataBind();
  };
  $scope.refreshConfig = function (snapshotDateData) {
    snapshotDateData = snapshotDateData || $scope.currentFilter;
    var config = fareChangeGridConfigurationService.prepareGridConfig($scope.aggregationMethod, snapshotDateData.snapshotDate);
    source.localdata = [];
    source.datafields = config.datafields;
    $scope.gridSettings.columns = config.columns;
    $scope.gridSettings.jqxGrid({
      source: new angular.element.jqx.dataAdapter(source),
      columns: config.columns
    });
  };
  $scope.menuItems = [{
    label: 'Departure Date Upsell'
  }];
  $scope.retrieveData = function (snapshotDateData) {
    $scope.currentFilter = snapshotDateData || $scope.currentFilter;
    return dataProviderService.getData($scope.currentFilter, $scope.aggregationMethod).then(function (data) {
      source.localdata = data;
      $scope.gridSettings.source.dataBind();
      return data;
    });
  };
  $scope.onSelectSnapshotDate = function (evt, selectedSnapshotDateData, latestSnapshotDate) {
    if (!selectedSnapshotDateData) {
      $scope.snapshotDate = null;
      $scope.runNumber = null;
      $scope.resetGrid();
      return;
    }
    if (latestSnapshotDate) {
      $scope.allowAfterSnapshotDate = latestSnapshotDate.clone().subtract(14, 'days').startOf('day');
    }
    $scope.refreshConfig(selectedSnapshotDateData);
    $scope.snapshotDate = selectedSnapshotDateData.snapshotDate;
    $scope.runNumber = selectedSnapshotDateData.runNumber;
    $scope.retrieveData(selectedSnapshotDateData);
  };
  $scope.onChangeMetric = function (evt, selectedMetric) {
    if (!_.isUndefined(selectedMetric.metric)) {
      heatmapColorService.setCurrentMetric(selectedMetric.metric);
      $scope.metricColorRange = heatmapColorService.getHeatMapColor();
      $scope.metricLabel = selectedMetric.gridLabel;
      $scope.retrieveData();
    }
  };
  $scope.onContextMenuClick = function (eventData) {
    goToAnalysis(eventData);
  };
  $scope.$watch('aggregationMethod', function (newAggregation, oldAggregation) {
    if (newAggregation !== oldAggregation) {
      $scope.aggregationMethod = newAggregation;
      $scope.refreshConfig();
      $scope.retrieveData();
    }
  });
  $scope.$on('brush-filter:filterApplied', function () {
    $scope.refreshConfig();
    $scope.retrieveData();
  });
  function goToAnalysis(eventData) {
    var transitionData = {
      timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP),
      searchCriteria: transitionSearchCriteriaService.pricingSummaryToAnalysis(eventData),
      snapshotDate: eventData.snapshotDate,
      cabin: eventData.cabin,
      direction: eventData.direction,
      market: eventData.market
    };
    if (runFrequency > 1) {
      transitionData.runNumber = eventData.runNumber;
    }
    $state.go('app.pricing-analysis', {
      transitionData: transitionData
    });
    window.scrollTo(0, 0);
  }
};
FareChangeGridController.$inject = ['$scope', '$state', 'FareChangeGridDataProviderService', 'FareChangeGridConfigurationService', 'FareChangeGridMetricHeatmapService', 'TransitionSearchCriteriaService', 'MomentService', 'HepService'];
module.exports = FareChangeGridController;